export const SIGNUP_ENTRY_QUERY = "?signup=1";

export const signupEntryPath = (onboardingBasePath) =>
  `${onboardingBasePath}${SIGNUP_ENTRY_QUERY}`;

export const isSignupDeepLink = (search) =>
  new URLSearchParams(search).get("signup") === "1";
